import { useState } from "react";
import {
  Briefcase,
  X,
  CurrencyDollar,
  Target,
} from "@phosphor-icons/react";
import { Button } from "../ui/button";

export function TrackingModal({ item, isDark, onConfirm, onClose }) {
  const [entryPrice, setEntryPrice] = useState("");
  const [amountInvested, setAmountInvested] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const price = parseFloat(entryPrice);
    const amount = parseFloat(amountInvested);
    if (isNaN(price) || isNaN(amount) || price <= 0 || amount <= 0) return;
    onConfirm(item, price, amount, notes);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="tracking-modal">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div
        className={`relative w-full max-w-md rounded-xl border p-6 shadow-2xl ${
          isDark
            ? "bg-[#12121a] border-white/10"
            : "bg-white border-gray-200"
        }`}
      >
        <button
          onClick={onClose}
          className={`absolute top-4 right-4 p-1 rounded-lg transition-colors ${
            isDark ? "hover:bg-white/10 text-gray-500" : "hover:bg-gray-100 text-gray-400"
          }`}
          data-testid="tracking-modal-close"
        >
          <X size={20} />
        </button>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
            <Briefcase size={20} className="text-white" weight="fill" />
          </div>
          <div>
            <h3 className={`font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
              Track Investment
            </h3>
            <p className={`text-sm font-body truncate max-w-[300px] ${isDark ? "text-gray-400" : "text-gray-600"}`}>
              {item.opportunity_title}
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className={`text-sm font-medium block mb-1 ${isDark ? "text-gray-300" : "text-gray-700"}`}>
              <CurrencyDollar size={14} className="inline mr-1" />
              Entry Price
            </label>
            <input
              type="number"
              step="0.01"
              min="0.01"
              value={entryPrice}
              onChange={(e) => setEntryPrice(e.target.value)}
              placeholder="e.g. 100.50"
              required
              className={`w-full px-3 py-2 rounded-lg border focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                isDark
                  ? "bg-[#0a0a14] border-white/10 text-white placeholder:text-gray-600"
                  : "bg-gray-50 border-gray-200 text-gray-900 placeholder:text-gray-400"
              }`}
              data-testid="tracking-entry-price"
              autoFocus
            />
          </div>

          <div>
            <label className={`text-sm font-medium block mb-1 ${isDark ? "text-gray-300" : "text-gray-700"}`}>
              <Target size={14} className="inline mr-1" />
              Amount Invested ($)
            </label>
            <input
              type="number"
              step="0.01"
              min="0.01"
              value={amountInvested}
              onChange={(e) => setAmountInvested(e.target.value)}
              placeholder="e.g. 10000"
              required
              className={`w-full px-3 py-2 rounded-lg border focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                isDark
                  ? "bg-[#0a0a14] border-white/10 text-white placeholder:text-gray-600"
                  : "bg-gray-50 border-gray-200 text-gray-900 placeholder:text-gray-400"
              }`}
              data-testid="tracking-amount"
            />
          </div>

          <div>
            <label className={`text-sm font-medium block mb-1 ${isDark ? "text-gray-300" : "text-gray-700"}`}>
              Notes (optional)
            </label>
            <input
              type="text"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="e.g. Entered after Q1 earnings report"
              className={`w-full px-3 py-2 rounded-lg border focus:outline-none focus:ring-2 focus:ring-purple-500 ${
                isDark
                  ? "bg-[#0a0a14] border-white/10 text-white placeholder:text-gray-600"
                  : "bg-gray-50 border-gray-200 text-gray-900 placeholder:text-gray-400"
              }`}
              data-testid="tracking-notes"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <Button
              type="button"
              onClick={onClose}
              className={`flex-1 rounded-lg ${
                isDark
                  ? "bg-white/5 hover:bg-white/10 text-gray-300"
                  : "bg-gray-100 hover:bg-gray-200 text-gray-700"
              }`}
              data-testid="tracking-cancel"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg"
              disabled={!entryPrice || !amountInvested}
              data-testid="tracking-confirm"
            >
              <Briefcase size={16} className="mr-1" />
              Track Investment
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
